import React from "react";
import { Phone, MessageCircle } from "lucide-react";

export default function FloatingCTAs() {
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3 items-end">
      <a
        href="https://wa.me/61434508712?text=Hi%20Taste%20of%20Egg%2C%20I'd%20like%20to%20order!"
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        aria-label="WhatsApp"
        className="group w-14 h-14 rounded-full flex items-center justify-center bg-[#25D366] shadow-[0_10px_30px_-5px_rgba(37,211,102,0.5)] hover:scale-110 transition-transform"
      >
        <MessageCircle className="w-6 h-6 text-white" />
      </a>
      <a
        href="tel:0434508712"
        data-testid="floating-call"
        aria-label="Call"
        className="group w-14 h-14 rounded-full flex items-center justify-center bg-yellow-brand shadow-[0_10px_30px_-5px_rgba(244,187,41,0.6)] hover:scale-110 transition-transform glow-yellow"
      >
        <Phone className="w-6 h-6 text-black" />
      </a>
    </div>
  );
}
